//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricAnalysis.SectionAnalysis.js";
import "../no/Builder.js";
import "../GeometricAnalysis/GeometricAnalysis.SectionAnalysis.CircularGridBuilder.js";
import "../GeometricUtilities/GeometricUtilities.CombOptionsBuilder.js";
import "../GeometricAnalysis/GeometricAnalysis.SectionAnalysis.QuadrilateralGridBuilder.js";
import "../no/SelectTaggedObjectList.js";
import "../GeometricAnalysis/GeometricAnalysis.SectionAnalysis.TriangularGridBuilder.js";
import "../no/GeometricAnalysis.js";
import "../no/GeometricUtilities.js";
import "../no/SelectObjectList.js";
let d=[[[0,"CalculationMethod",1,0],[1,"CircularGrid",0,"GeometricAnalysis.SectionAnalysis.CircularGridBuilder",0],[1,"CombOptions",0,"GeometricUtilities.CombOptionsBuilder",0],[0,"NeedleDirection",1,0],[0,"Output",1,0],[1,"QuadrilateralGrid",0,"GeometricAnalysis.SectionAnalysis.QuadrilateralGridBuilder",0],[1,"References",0,"SelectTaggedObjectList",0],[0,"ScalingMethod",1,0],[0,"ShowInflectionPoints",1,0],[0,"ShowPeakPoints",1,0],[0,"ShowSectionLength",1,0],[1,"TriangularGrid",0,"GeometricAnalysis.SectionAnalysis.TriangularGridBuilder",0],[0,"Type",1,0]],[],[]];
SPLM.GeometricAnalysis.SectionAnalysis.SectionAnalysisBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricAnalysis.SectionAnalysis.SectionAnalysisBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricAnalysis.SectionAnalysis.SectionAnalysisBuilder.Types = Object.freeze({
    "Parallel" : "Parallel", "Isoparametric" : "Isoparametric", "AlongCurve" : "AlongCurve", "Quadrilateral" : "Quadrilateral", "Triangular" : "Triangular", "Circular" : "Circular"});

SPLM.GeometricAnalysis.SectionAnalysis.SectionAnalysisBuilder.OutputType = Object.freeze({
    "AnalysisObject" : "AnalysisObject", "SectionCurves" : "SectionCurves", "Both" : "Both"});

SPLM.GeometricAnalysis.SectionAnalysis.SectionAnalysisBuilder.NeedleDirectionType = Object.freeze({
    "Inside" : "Inside", "Outside" : "Outside"});

SPLM.GeometricAnalysis.SectionAnalysis.SectionAnalysisBuilder.CalculationMethodType = Object.freeze({
    "Curvature" : "Curvature", "RadiusofCurvature" : "RadiusofCurvature"});

SPLM.GeometricAnalysis.SectionAnalysis.SectionAnalysisBuilder.ScalingMethodType = Object.freeze({
    "Linear" : "Linear", "Logarithmic" : "Logarithmic"});

export default SPLM;